import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { emptyObj, getRequestData, failAlert, FORM_ITEM_SAME_INS_ADDR } from '@/utils';
import { subsTransferCheckBsnl, subsTransferBsnl, qryOfferForShifting } from '@/pages/Transfer/services/transfer';

import { qrySubsMemDetail } from '@/services/business';

export default {
  namespace: 'transfer',
  state: {
    step: 0, // 过户业务流程的步骤
    searchCustInfo: {}, // 从搜索页面同步过来的用户信息
    serviceType: {}, // 从搜索页面同步过来的服务类型
    subServiceType: {}, // 从搜索页面同步过来的子服务类型
    comboUnitNbrFlagList: [], // combo子套餐手机号是否必填列表
    canTransfer: true,
    canShifting: true,
    canNumUse: true,
    canPlanUse: true,
    canAcctUse: true,
    isCombo: false, // 是不是combo
  },
  effects: {
    *subsTransferCheckBsnl({ payload }, { call, put, select }) {
      const res = yield call(subsTransferCheckBsnl, payload);
      const result = getRequestData(res, false) || {};
      const { returnCode, returnMsg, transferFlag, shiftingFlag, offerFlag, accNbrFlag, acctNbrFlag, comboUnitAccNbrFlagDtoList = [] } = result;
      if (`${returnCode}` !== '0') {
        // 提示后端check内容
        failAlert({ title: '', content: returnMsg });
      }
      const isCombo = !isEmpty(comboUnitAccNbrFlagDtoList);
      const params = {
        canTransfer: transferFlag === 'Y',
        canShifting: shiftingFlag === 'Y',
        canAcctUse: acctNbrFlag === 'Y',
        canNumUse: accNbrFlag === 'Y',
        canPlanUse: offerFlag === 'Y',
        isCombo,
      };
      let comboUnitNbrFlagList = comboUnitAccNbrFlagDtoList;
      if (!isEmpty(comboUnitAccNbrFlagDtoList)) {
        // 查询主订户套餐详情，并组装数据
        const { custId } = yield select(state => state.transfer);
        const mainSubsDetail = yield call(qrySubsMemDetail, { custId, subsId: payload.subsId });
        const { subsDto = {} } = getRequestData(mainSubsDetail, false);
        comboUnitNbrFlagList = comboUnitNbrFlagList.map(combo => {
          const comboDetail = (get(subsDto, 'subsMemberDtoList') || []).find(it => `${combo.subsId}` === `${it.subsId}`) || {};
          return {
            ...combo,
            comboDetail,
          };
        });
      }
      yield put({
        type: 'save',
        payload: {
          comboUnitNbrFlagList,
          ...params,
        },
      });
      return { ...params, ...result };
    },

    *subsTransferBsnl({ payload }, { call }) {
      const res = yield call(subsTransferBsnl, payload);
      return getRequestData(res);
    },

    *qryOfferForShifting({ payload }, { call, select }) {
      const { selectSubsInfo, subsDetail } = yield select(state => state.transfer);
      const { accountInfo, newInstallationAddress, custId } = yield select(state => state.transferCustomer);
      const custAddressId = get(newInstallationAddress, 'custAddressId');
      // 区别只过户不移机的情况
      const installationAddressId = custAddressId !== FORM_ITEM_SAME_INS_ADDR ? custAddressId : get(subsDetail, 'installationAddressDto.custAddressId');
      const params = {
        subsId: get(selectSubsInfo, 'subsId'),
        installationAddressId,
        newAcctNbr: get(accountInfo, 'acctBasicInfo.acctNbr'),
        newCustId: custId,
        offerName: payload.offerName,
        pageDto: {
          pageIndex: get(payload, 'pageInfo.currentPage') || 1,
          pageCount: get(payload, 'pageInfo.pageSize') || 7,
        },
      };
      const response = yield call(qryOfferForShifting, params);
      const { availableOfferDtoList, pageDto } = getRequestData(response, false);
      return {
        offerList: availableOfferDtoList || [],
        pageDto: {
          currentPage: get(pageDto, 'pageIndex'),
          pageSize: get(pageDto, 'pageCount'),
          total: get(pageDto, 'totalRecord') || 0,
        },
      };
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear(state) {
      return emptyObj(state);
    },
  },
};
